import "../css/dashboard.css";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import MAVideosLinksMobile from "../component/Misc/MAVideosLinksMobile";

export default function MobileAppSetContentMobile() {

  return (
    <div className="right-container-mobile">
      <TopTitleBannerMobile title={"Client Mobile App Settings"} />
      <MAVideosLinksMobile />
    </div>
  );
}
